import { RecentlyViewed } from '@theme/recently-viewed-products';
import { sectionRenderer } from '@theme/section-renderer';

document.addEventListener('DOMContentLoaded', () => {
  /** @type {HTMLElement | null} */
  const section = document.querySelector('[data-section-type="recently-viewed-collection"]');
  if (!section) return;

  const sectionId = section.dataset.sectionId;
  if (!sectionId) return;

  const viewedProducts = RecentlyViewed.getProducts();
  if (!viewedProducts || viewedProducts.length === 0) {
    section.style.display = 'none';
    return;
  }

  try {
    const url = new URL(Theme.routes.search_url, window.location.origin);
    url.searchParams.set(
      'q',
      viewedProducts.map((id) => `id:${id}`).join(' OR '),
    );
    url.searchParams.set('resources[type]', 'product');

    sectionRenderer.renderSection(sectionId, { cache: false, url });
  } catch (error) {
    console.error('Failed to render recently viewed products section', error);
  }
});

